import { alpha, Box, styled, Typography } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";

export const StyledTitleContainer = styled(FlexBox)(({ theme }) => ({
  columnGap: "8px",
  flexWrap: "nowrap",

  [theme.breakpoints.down("tablet")]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "center",
  },
}));

export const StyledStarBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "-20px",
  left: "-45px",

  [theme.breakpoints.down("tablet")]: {
    top: "-10px",
    left: "-40px",
  },
}));

export const StyledTitleBox = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
}));

export const StyledTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "size",
})<{ size?: "large" | "medium" }>(({ theme, size = "large" }) => ({
  fontFamily: "Noto Sans TC",
  color: theme.palette.primary.main,
  position: "relative",
  background: "linear-gradient(180deg, #95FF9C 4.81%, #0D8854 80%)",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontSize: size === "large" ? "88px" : "48px",
  textShadow: `0px 8px 16px ${alpha(theme.palette.grey[500], 0.16)}`,
  fontWeight: "900",
  lineHeight: 1.2,
  whiteSpace: "nowrap",

  [theme.breakpoints.down("tablet")]: {
    fontSize: "60px",
  },

  "&::after": {
    position: "absolute",
    top: "0",
    left: "0",
    content: "attr(data-after)",
    zIndex: "-1",
    WebkitTextStrokeWidth: "6px",
    WebkitTextStrokeColor: theme.palette.common.white,
  },
}));

export const StyledSpecialTitle = styled(StyledTitle)<{
  size?: "large" | "medium";
}>(({ theme, size = "large" }) => ({
  fontFamily: "Kodchasan",
  fontSize: size === "large" ? "98px" : "58px",
  fontWeight: theme.typography.fontWeightBold,
}));
